@if (isNewRecord() && !(consumerError() || subjectError())) {
    <h2 mat-dialog-title class="cut-long-text">Neue Funktionale Hilfe/Tipps</h2>
} @else {
    <h2 mat-dialog-title class="cut-long-text">
        Funktionale Hilfe/Tipps
        <span class="name">{{ this.data.name }}</span> bearbeiten
    </h2>
}
<mat-divider></mat-divider>
<mat-dialog-content>
    <mat-tab-group id="tab-group">
        <form [formGroup]="formGroup">
            <mat-tab label="Bearbeiten">
                <br />
                <div>
                    <mat-form-field>
                        <mat-label>Name</mat-label>
                        <input matInput type="text" required placeholder="" formControlName="name" name="name" />
                        <mat-error>{{ checkName(formGroup.controls["name"]) }}</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field>
                        <mat-label>Konsument</mat-label>
                        <mat-select formControlName="consumerId" (valueChange)="consumerChanged($event)">
                            @for (consumer of consumers; track consumer) {
                                <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                            }
                        </mat-select>
                        @if (consumerError()) {
                            <mat-error>{{ getConsumerError() }}</mat-error>
                        }
                        @if (consumerIsDeleted()) {
                            <mat-error>Der Eintrag für dieses Feld existiert nicht mehr</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div>
                    @if (consumerIsDeleted()) {
                        <br />
                    }
                    <mat-form-field>
                        <mat-label>Fach/Beruf</mat-label>
                        <mat-select formControlName="subjectId" (valueChange)="competencyChanged($event)">
                            @for (competency of competencies; track competency) {
                                <mat-option [value]="competency.treeId">{{ competency.name }}</mat-option>
                            }
                        </mat-select>
                        @if (competencyIsDeleted()) {
                            <mat-error>Der Eintrag für dieses Feld existiert nicht mehr</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div>
                    @if (competencyIsDeleted()) {
                        <br />
                    }
                    <mat-form-field appearance="outline">
                        <mat-label>Aufgabentyp</mat-label>
                        <mat-select formControlName="exerciseKind">
                            @for (kind of kinds; track kind) {
                                <mat-option [value]="kind.value">{{ kind.option }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </mat-tab>

            @if (!isNewRecord()) {
                <mat-tab label="Inhalt">
                    <div class="content-container">
                        <div>Text</div>
                        <div>
                            <button class="extend-button" mat-stroked-button (click)="openEditor()" aria-label="Editor">Editor</button>
                        </div>
                        <div>
                            @if (this.data.markupText && this.data.markupText.length > 0) {
                                <div class="media-container">
                                    <div class="media-item">
                                        <button mat-icon-button matTooltip="Audio-Datei löschen" class="button-delete" (click)="deleteEditorContent()">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                    <div class="pixl-editor-wrapper">
                                        <div class="media-item-editor" [innerHTML]="this.viewContentHtml()"></div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <div class="content-container">
                        <div>Audio</div>
                        <div>
                            <button class="extend-button" mat-stroked-button (click)="openAudioChoice(true)" aria-label="DesktopAudio">
                                <mat-icon>music_note</mat-icon>
                                Audio aus Medien
                            </button>
                            @if (getDesktopAudioName() && getDesktopAudioName().length > 0) {
                                <div class="info cut-long-text">
                                    {{ getDesktopAudioName() }}
                                </div>
                            }
                        </div>
                        <div>
                            @if (getDesktopAudioName() && getDesktopAudioName().length > 0) {
                                <div class="media-container">
                                    <div class="media-item">
                                        <button mat-icon-button matTooltip="Audio-Datei löschen" class="button-delete" (click)="deleteMediaEntry(true, true)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                    <div class="media-item">
                                        <audio #desktopAudioCtrl controls preload="auto" class="audio-control">
                                            <source src="{{ desktopAudioUrl() }}" type="audio/mpeg" />
                                            Your browser does not support the audio element.
                                        </audio>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <div class="content-container">
                        <div>Audio (mobile)</div>
                        <div>
                            <button class="extend-button" mat-stroked-button (click)="openAudioChoice(false)">
                                <mat-icon>music_note</mat-icon>
                                Audio aus Medien
                            </button>
                            @if (getMobileAudioName() && getMobileAudioName().length > 0) {
                                <span class="info cut-long-text">{{ getMobileAudioName() }}</span>
                            }
                        </div>
                        <div>
                            @if (getMobileAudioName() && getMobileAudioName().length > 0) {
                                <div class="media-container">
                                    <div class="media-item">
                                        <button mat-icon-button matTooltip="Audio-Datei löschen" class="button-delete" (click)="deleteMediaEntry(true, false)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                    <div class="media-item">
                                        <audio #mobileAudioCtrl controls preload="auto" class="audio-control">
                                            <source src="{{ mobileAudioUrl() }}" type="audio/mpeg" />
                                            Your browser does not support the audio element.
                                        </audio>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <div class="content-container">
                        <div>Bild</div>
                        <div>
                            <button class="extend-button" mat-stroked-button (click)="openImageChoice()">
                                <mat-icon>add_photo_alternate</mat-icon>
                                Bild aus Medien
                            </button>
                            @if (getImageName() && getImageName().length > 0) {
                                <span class="info cut-long-text">{{ getImageName() }}</span>
                            }
                            <br />
                        </div>
                        <div>
                            @if (getImageName() && getImageName().length > 0) {
                                <div class="media-container">
                                    <div class="media-item">
                                        <button mat-icon-button matTooltip="Bild-Datei löschen" class="button-delete" (click)="deleteMediaEntry(false, false)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                    <div class="media-item">
                                        <img src="{{ imageUrl() }}" alt="" class="preview" />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </mat-tab>
            }
        </form>
    </mat-tab-group>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="onCancel()">Abbruch</button>
    <button mat-raised-button (click)="onSave()" [disabled]="!formGroup.valid || approval()">Speichern</button>
</mat-dialog-actions>
